"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = exports.Title = exports.styles = exports.CardWrap = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
exports.CardWrap = app_1.styled.div `
  background-color: white;
  border-radius: ${(theme) => theme.radius.big};
  padding: ${(theme) => theme.spacing.small} 0;
`;
exports.styles = {
    card: {
        noInnerPadding: (0, app_1.css) `
      padding: ${(theme) => theme.spacing.small};

      > .card-title {
        padding: ${(theme) => theme.spacing.small} 1.5rem;
        padding-top: 0;
      }
    `,
    },
    section: {
        noOuterPadding: (type) => (0, app_1.css) `
      padding: 0;

      ${type === 'horizontal' &&
            (0, app_1.css) `
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
      `}

      ${type === 'vertical' &&
            (0, app_1.css) `
        padding-left: 1.5rem;
        padding-top: 1.5rem;
      `}


      ${type === 'outer' &&
            (0, app_1.css) `
        padding: 1.5rem;
      `}
    `,
        noTopPadding: (0, app_1.css) `
      &:first-of-type {
        padding-top: 0;
      }
    `,
        separated: (0, app_1.css) `
      border-top: 1px solid ${(theme) => theme.stroke};
      padding-top: 1.5rem;
    `,
    },
};
const TitleText = app_1.styled.span `
  color: ${(theme) => theme.colors.primary.deep};
  font-weight: 500;
  font-size: 0.9475rem;
  white-space: nowrap;
  margin-bottom: ${(theme) => theme.spacing.extraSmall};
  padding: 0 1.5rem;
  padding-bottom: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(theme, { $noLine }) => !$noLine &&
    (0, app_1.css) `
      border-bottom: 1px solid ${theme.stroke};
    `}
`;
function Title({ title, noLine, children, }) {
    if (!title) {
        return null;
    }
    if (typeof title === 'string') {
        return ((0, jsx_runtime_1.jsxs)(TitleText, Object.assign({ className: "card-title", "$noLine": Boolean(noLine) }, { children: [title, children] })));
    }
    return title;
}
exports.Title = Title;
exports.Section = app_1.styled.div `
  padding: ${(theme) => theme.spacing.small};
`;
